import { createContext, useContext } from "react";

/** Lets a page apply choices that are filled in but not yet sent (e.g. free text) before it navigates away. */
export interface PendingChoices {
  register: (id: string, submit: (() => Promise<boolean>) | null) => void;
}

export const PendingChoicesContext = createContext<PendingChoices | null>(null);

export const usePendingChoices = () => useContext(PendingChoicesContext);
